<template>
  <div id="signature-tools " :class="{'signature-tools-mobile': !isDesktop, 'signature-tools-desktop': isDesktop}">
    <!-- Open Customizer Button -->
    <vs-button
      v-if="isDesktop && isAuthenticated"
      @click.stop="openSidebar"
      @mouseover="showIcon = true"
      @mouseleave="showIcon = false"
      color="primary"
      type="filled"
      class="sub-tools-btn config-menu"
      icon-pack="feather"
      icon="PlaylistIcon"
    >
      <feather-icon
            icon="PlaylistIcon"
            class="playlist-icon subtools"
        v-if="isDesktop && showIcon"
        @click.stop="active=!active"
      />
    </vs-button>  
    <!-- Customizer Content -->
    <!-- click-not-close hidden-background -->
    <vs-sidebar v-model="active" position-right class="items-no-padding playlist-sidebar" :class="{'playlist-sidebar-active': active}">
      <div class="customizer-content">
        <div class="customizer-header flex items-center justify-center px-6">
          <div class="customizer-menu">
             <!-- <b-button
              variant="outline-primary"
              class="mr-1 customizer-menu-btn"
               @click="displayNotifications()"
               :class="{'selected': tools.notification}"
            >
              <feather-icon
                icon="BellIcon"
                size="12"
                badge="6"
              />
              <span class="align-middle custom-btn-text">Notificações</span>
            </b-button> -->
             <b-button
              variant="outline-primary"
              class="mr-1 customizer-menu-btn"
               @click="displayPlaylist()"
               :class="{'selected': tools.playlist}"
            >
              <feather-icon
                icon="PlayIcon"
                class=""
              />
              <span class="align-middle custom-btn-text">Playlist</span>
            </b-button>
             <b-button
              variant="outline-primary"
              class="mr-1 customizer-menu-btn"
               @click="displayCalendar()"
               :class="{'selected': tools.calendar}"
            >
              <feather-icon
                icon="CalendarIcon"
              />
              <span class="align-middle custom-btn-text">Agenda</span>
            </b-button>
             <!-- <b-button
              variant="outline-primary"
              class="mr-1 customizer-menu-btn"
               @click="displayWeather()"
               :class="{'selected': tools.weather}"
            >
              <feather-icon
                icon="CloudIcon"
                size="12"
              />
              <span class="align-middle custom-btn-text">Clima</span>
            </b-button> -->
                         
            
            <!-- <vs-button type="flat" icon-pack="feather" icon="icon-bell" :class="{'selected': tools.notification}" @click="displayNotifications()">
              Notificações
            </vs-button>
            <vs-button type="flat" icon-pack="feather" icon="icon-play" :class="{'selected': tools.playlist}" @click="displayPlaylist()">Playlist</vs-button>
            <vs-button type="flat" icon-pack="feather" icon="icon-calendar" :class="{'selected': tools.calendar}" @click="displayCalendar()">Agenda</vs-button>
            <vs-button type="flat" icon-pack="feather" icon="icon-cloud" :class="{'selected': tools.weather}" @click="displayWeather()">Clima</vs-button> -->
            <!-- <vs-button type="flat" icon-pack="feather" icon="icon-settings" @click="displayConfig()">Configurações</vs-button> -->
          </div>
          
          <feather-icon v-if="!isDesktop" icon="XIcon" @click.stop="active = false" class="cursor-pointer close-icon-customizer"></feather-icon>
            <!-- <h4>{{title}}</h4> -->
        </div>
        <!-- <small>Customize & Preview in Real Time</small> -->

        <!-- <vs-divider class="mb-0" /> -->
        
        <template v-if="tools.playlist">
          <playlist-tools :isDesktop="isDesktop" @close="closePlaylist" @open-register="openRegister"></playlist-tools>
        </template>
        <!-- <template v-else-if="tools.notification">
          <notifications></notifications>
        </template> -->
        <template v-else-if="tools.weather">
          <weather-detail></weather-detail>
        </template>
        <template v-else-if="tools.calendar">
          <schedules @open-news-detail="openNewsDetail"></schedules>
        </template>
        <!-- 
        <template v-else-if="tools.config"></template> -->
          <!-- <div class="px-6">
            <vs-divider />
            <vs-divider />
          </div> -->
        <!-- <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings"></VuePerfectScrollbar> -->
      </div>
    </vs-sidebar>
  </div>
</template>


<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import PlaylistTools from "./modules/PlaylistTools"
import { EventBus } from '../../../event-bus';
import AppConstants from '../../../appConstants';
import {
  BBadge,
  BButton
} from 'bootstrap-vue'
import Notifications from './modules/Notifications.vue';
import Schedules from './modules/Schedules.vue';
import WeatherDetail from './modules/WeatherDetail.vue';

export default {
  props: {
    isDesktop: {
      required: true
    }
  },
  data() {
    return {
      showIcon: false,
      active: false,
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: '',
      tools: {
        playlist: true,
        notification: false,
        weather: false,
        config: false,
        calendar: false
      }
    };
  },
  watch: {
    active(val) {
      this.$store.dispatch('updatePlaylistOpen', val);
    },
    "tools.playlist"(value) {
      if (value) {
        this.tools.notification = false;
        this.tools.weather = false;
        this.tools.config = false;
        this.tools.calendar = false;
      }
    },
    "tools.notification"(value) {
      if (value) {
        this.tools.playlist = false;
        this.tools.weather = false;
        this.tools.config = false;
        this.tools.calendar = false;
      }
    },
    "tools.weather"(value) {
      if (value) {
        this.tools.playlist = false;
        this.tools.notification = false;
        this.tools.config = false;
        this.tools.calendar = false;
      }
    },
    "tools.config"(value) {
      if (value) {
        this.tools.playlist = false;
        this.tools.notification = false;
        this.tools.weather = false;
        this.tools.calendar = false;
      }
    },
    "tools.calendar"(value) {
      if (value) {
        this.tools.playlist = false;
        this.tools.notification = false;
        this.tools.config = false;
        this.tools.weather = false;
      }
    }
  },
  computed: {
    playlistActive() {
      return this.$store.state.playlistOpen;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
  },
  mounted() {
    EventBus.$on('open-calendar', this.displayCalendar);
    // this.title = 'Ferramentas do Assinante';
    this.displayPlaylist();

    EventBus.$on(AppConstants.BUS_EVENT_OPEN_PLAYLIST, (val) => {
      this.$store.dispatch('updatePlaylistOpen', val);
      this.active = val;
      this.displayPlaylist();
    });
    EventBus.$on(AppConstants.BUS_EVENT_CLOSE_PLAYLIST, () => {
      this.closePlaylist();
      this.displayPlaylist();
    });
    this.getNotificationData();
  },
  destroyed() {
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_PLAYLIST);
    EventBus.$off('open-calendar', this.displayCalendar);
  },
  methods: {
    openNewsDetail(newsData) {
      console.log('[openNewsDetail]', newsData);
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_REPORT_DETAIL, newsData);
      this.closeSidebar();

    },
    getScheduleData() {
      const scheduleData = [];
      for (let index = 0; index < 6; index++) {
        scheduleData.push({
          id: '65a99723795e5a20cc57057b',
          title: `Titulo da noticia ${index + 1}`,
          hat: [{name: `Chapeu ${index + 1}`}],
          dt_publish: new Date(),
          author: {name: 'Autor'},
          newsContent: [{code: 1}],
          subjects: [{code: 1, namePtBr: 'Assunto', labelPtBr: 'Assunto'}],
          displayDetail: true
        });
      }
      this.$store.dispatch('setScheduleData', scheduleData);
    },
    getNotificationData() {
      const notificationData = [];
      for (let index = 0; index < 6; index++) {
        notificationData.push({
          title: `Nova notificação ${index+1}`, 
          message: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
        });
      }
      this.$store.dispatch('setNotification', notificationData);
    },
    openSidebar() {
      if (this.isAuthenticated) {
        this.active=!this.active;
      } else {
        EventBus.$emit(AppConstants.BUS_EVENT_OPEN_EXCLUSIVE_CONTENT_POPUP);
      }
    },
    closeSidebar() {
      this.active = false;
    },
    openRegister() {
      this.closePlaylist();
        setTimeout(() => {
          EventBus.$emit(AppConstants.BUS_EVENT_OPEN_REGISTER);
        }, 200);
    },
    closePlaylist() {
      this.$store.dispatch('updatePlaylistOpen', false);
      this.closeSidebar();
    },
    displayPlaylist() {
      this.title = 'Playlist';
      this.tools.playlist = true;
    },
    displayNotifications() {
      this.title = 'Notificações';
      this.tools.notification = true;
    },
    displayWeather() {
      this.title = 'Clima';
      this.tools.weather = true;
    },
    displayCalendar() {
      this.title = 'Agenda';
      this.tools.calendar = true;
      this.active = true; 
    },
    displayConfig() {
      this.title = 'Configurações';
      this.tools.config = true;
    },
  },
  components: {
    VuePerfectScrollbar,
    PlaylistTools,
    BBadge,
    BButton,
    Notifications,
    Schedules,
    WeatherDetail
  }
};
</script>


<style lang="scss">

</style>

